class Subscriptions {
  constructor() {
    this.init()
  }

  init () {
    this.cacheDOM()
    this.bindEvents()
  }

  cacheDOM () {
  }

  bindEvents () {
    this.handlePlanDurationChange()
    $( '.summary-academy-users' ).syncInput( {
      target: ".summary-academy-users",
      event: "updated"
    } )

    $( '.summary-academy-plan' ).syncInput( {
      target: ".summary-academy-plan",
      event: "change"
    } )

    $( '.summary-academy-period' ).syncInput( {
      target: ".summary-academy-period",
      event: "change"
    } )
  }

  handlePlanDurationChange () {
    $( 'input[name=period_radio]' ).on( 'change', function ( e ) {
      const currentValue = $( 'input[name=period_radio]:checked' ).val()

      console.log( currentValue )

      $( '#plan_form' ).find( '.pricing' ).each( function ( e ) {
        console.log( currentValue )
        if ( 'annual' === currentValue ) {
          $( '#plan_form' ).find( '.pricing' ).removeClass( 'monthly' )
        } else if ( 'monthly' === currentValue ) {
          $( '#plan_form' ).find( '.pricing' ).addClass( 'monthly' )
        }
      } )
    } )
  }

}

new Subscriptions()
